import { isInternational } from 'helpers/location';
import { ValidateJSModel, ValidateJSModelAttribute } from 'forms/shared/types';
import locationModelValidator from '../location';
import { LocationModel } from '../types';
import { inheritModel } from '../../shared/modelHelper';

interface LocationBirthplaceModel {
  city: LocationModel['city']
  state: LocationModel['state']
  country: LocationModel['country']
  county: LocationModel['county']
}

const locationBirthplaceModelValidator: ValidateJSModel<LocationBirthplaceModel> = {
  city: (value, attributes, attributeName, options) => {
    const inherited = inheritModel(
      locationModelValidator.city,
      value,
      attributes,
      attributeName,
      options
    );

    if (options.requireCity === false || (!!attributes.county && options.requireCityOrCounty)) {
      return {
        ...inherited,
        presence: false,
        length: {},
      };
    }
    return {
      ...inherited,
      presence: true,
    };
  },

  state: locationModelValidator.state as ValidateJSModelAttribute<LocationBirthplaceModel, 'state'>,

  country: locationModelValidator.country as ValidateJSModelAttribute<
    LocationBirthplaceModel,
    'country'
  >,

  county: (value, attributes, attributeName, options) => {
    const inherited = inheritModel(
      locationModelValidator.county,
      value,
      attributes,
      attributeName,
      options
    );

    if (
      options.requireCounty === false
      || isInternational(attributes)
      || (!!attributes.city && options.requireCityOrCounty)
    ) {
      return {
        ...inherited,
        presence: false,
      };
    }
    return {
      ...inherited,
      presence: true,
    };
  },
};

export default locationBirthplaceModelValidator;
